import React, { useEffect,useState } from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { FiAward, FiUsers, FiTrendingUp, FiTarget } from 'react-icons/fi';
import { API_BASE_URL, institute_id } from '../config/config';
import { useNavigate,useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';
const AboutUs = () => {
  const navigate = useNavigate();
  const location = useLocation();
const slug=location.pathname.split('/').pop();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const settings=JSON.parse(localStorage.getItem('settings'));

  useEffect(() => {
    fetchBlogPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);
  const fetchBlogPost = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(`${API_BASE_URL}/pages${location?.pathname}?institute_id=${institute_id}`);
      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
     setPost(data.data[0]);
      } else {
        setError('Page not found');
      }
    } catch (error) {
      console.error('Error fetching page:', error);
      setError('Failed to load page. Please try again later.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary-500 to-purple-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About US</h1>
          <p className="text-xl md:text-2xl opacity-90">Your Gateway to Success in Competitive Exams</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Our Story */}
          <div className="max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Our Story</h2>
            <div 
  className="prose prose-lg max-w-none text-gray-700"
  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post?.description) }}
/>
          
          </div>

          {/* Mission & Vision */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="card bg-gradient-to-br from-blue-50 to-blue-100">
              <div className="w-16 h-16 bg-primary-500 text-white rounded-lg flex items-center justify-center mb-4 text-2xl">
                🎯
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-gray-700 leading-relaxed">
                To empower students with quality education, comprehensive study materials, and expert guidance to help them achieve their goals in competitive examinations and build successful careers.
              </p>
            </div>

            <div className="card bg-gradient-to-br from-purple-50 to-purple-100">
              <div className="w-16 h-16 bg-purple-600 text-white rounded-lg flex items-center justify-center mb-4 text-2xl">
                👁️
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              <p className="text-gray-700 leading-relaxed">
                To become the most trusted and preferred educational platform for competitive exam preparation, recognized for our commitment to excellence, innovation, and student success.
              </p>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Why Choose Us?</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="card text-center">
                <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FiAward className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Expert Faculty</h3>
                <p className="text-gray-600">
                  Learn from experienced educators with proven track records
                </p>
              </div>

              <div className="card text-center">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FiUsers className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Student Success</h3>
                <p className="text-gray-600">
                  Thousands of successful students who achieved their goals
                </p>
              </div>

              <div className="card text-center">
                <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FiTrendingUp className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Quality Content</h3>
                <p className="text-gray-600">
                  Comprehensive and up-to-date study materials
                </p>
              </div>

              <div className="card text-center">
                <div className="w-16 h-16 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FiTarget className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Focused Approach</h3>
                <p className="text-gray-600">
                  Strategic preparation methods for better results
                </p>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="bg-gradient-to-r from-primary-500 to-purple-600 text-white rounded-2xl p-12">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-5xl font-bold mb-2">1000+</div>
                <div className="text-xl opacity-90">Happy Students</div>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">50+</div>
                <div className="text-xl opacity-90">Quality Courses</div>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">95%</div>
                <div className="text-xl opacity-90">Success Rate</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;

